// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ASK_AN_EXPERT = "Poradny";
export const BACK_TO_TOPICS = "Zp\u011bt na f\u00f3ra";
export const COUNSELLING_IS_ARCHIVED = "Poradna je uzav\u0159ena";
export const FORUM = "F\u00f3ra";
export const FORUM_ADD_QUESTION = "Polo\u017e anonymn\u00ed ot\u00e1zku";
export const FORUM_ADD_REPLY = "Sem za\u010dni ps\u00e1t odpov\u011b\u010f...";
export const REPORTED_COMMENTS = "Nahl\u00e1\u0161en\u00e9 koment\u00e1\u0159e";
export const SEND_COMMENT_FORUM = "Ode\u0161li";
